import { BaseSpecialRenderer, SpecialFieldJsonData } from './base-special-renderer';
import { AccountRuntimeConfig, RenderOptions } from '../../models/element-types';

export interface AccountIdJsonData extends SpecialFieldJsonData {
    type: 'accountId';
    accountId?: string;
}

export class AccountIdRenderer extends BaseSpecialRenderer<AccountIdJsonData> {
    protected override get defaultData(): AccountIdJsonData {
        return {
            id: '',
            type: 'accountId'
        };
    }

    protected override renderElement(data: AccountIdJsonData, options?: RenderOptions): HTMLElement {
        const accountConfig = (options?.runtimeContext as any)?.account as AccountRuntimeConfig;

        const container = document.createElement('div');
        container.classList.add('account-id-container');
        container.style.display = 'none';

        if (!accountConfig?.accountId) {
            console.warn('Account runtime config not provided');
            return container;
        }

        const input = document.createElement('input');
        input.type = 'hidden';
        input.id = '__accountId';
        input.name = '__accountId';
        input.value = accountConfig.accountId;

        container.appendChild(input);

        return container;
    }
}
